// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type AnyAction } from '@reduxjs/toolkit';
import { VerticalSlider } from '@advisor-app/components/vertical-slider';
import {
  type FactorRange,
  type SetFactorsFilter,
} from '@shared/data-access/interfaces/redux/parameters-state';

interface FactorsProps {
  names: string[];
  states: FactorRange[];
  setFactors: (factor: SetFactorsFilter) => AnyAction;
  testId?: string;
}

export const Factors = ({
  names,
  states,
  setFactors,
  testId = 'factors',
}: FactorsProps) => {
  return (
    <div className="flex justify-around" data-testid={testId}>
      {names.map((name, idx) => (
        <VerticalSlider
          key={idx}
          name={name}
          state={states[idx]?.ranges || [0, 100]}
          index={idx}
          saveValuesOnRedux={setFactors}
        />
      ))}
    </div>
  );
};
